<template>
  <v-dialog value="true" fullscreen hide-overlay persistent content-class="analise__scroll">
    <v-card tile color="#fff">
      <analise-demanda-cabecalho-credenciamento-fornecedor
          :key="key"
          v-model="credenciamento.analiseDemanda"
          @voltar="tratarEventoDeVoltar"
      />
      <analise-documentacao-demanda-credenciamento-fornecedor v-if="exibir"
                                                     :documento.sync="credenciamento.analiseDemanda.documento"
                                                     @downloadDocumento="tratarEventoDownload"/>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from 'vuex';
import AnaliseDemandaCabecalhoCredenciamentoFornecedor
  from "@/views/credenciamento/detalhe-credenciamento/fornecedor/execucao/analise/cabecalho/AnaliseDemandaCabecalhoCredenciamentoFornecedor.vue";
import actionTypes from "@/commons/constants/action-types";
import AnaliseDocumentacaoDemandaCredenciamentoFornecedor
  from "@/views/credenciamento/detalhe-credenciamento/fornecedor/execucao/analise/documento/AnaliseDocumentacaoDemandaCredenciamentoFornecedor.vue";

export default {
  name: 'AnaliseDemandaCredenciamentoFornecedor',
  components: {
    AnaliseDocumentacaoDemandaCredenciamentoFornecedor,
    AnaliseDemandaCabecalhoCredenciamentoFornecedor
  },
  data() {
    return {
      demandaId: null,
      credenciamentoId: null,
      demanda: null,
      exibir: false,
      documentoSelecionado: {
        url: ''
      },
      credenciamento: {
        analiseDemanda: {
          id: '',
          sequencia: '',
          numero: '',
          siglaUnidadeOrganizacional: '',
          razaoSocial: '',
          situacao: '',
          uriRelatorioFornecimentoPedido: '',
          motivoNaoCredenciamento: '',
          documento: '',
        }
      },
      key: 0,
    };
  },
  computed: {
    ...mapState(['parametros', 'loki', 'licitacao']),
  },
  async mounted() {
    this.receberDadosDaRota();
    if (!this.demanda && this.demandaId) {
      await this.buscarDemandaPorId();
    }

    if (this.demanda) {
      this.preencherCabecalhoDemanda();
      await this.buscarDocumentosParaAnalisar()
      await this.exibirAnalise()
    } else {
      this.mostrarNotificacaoErro('Contratação não encontrada.');
    }
  },
  methods: {
    receberDadosDaRota() {
      this.credenciamentoId = this.$route.params.id;
      this.demandaId = this.$route.params.demandaId;
    },
    async buscarDemandaPorId() {
      const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_DEMANDA_POR_ID, { demandaId: this.demandaId });
      if (response) {
        this.demanda = response;
      }
    },

    preencherCabecalhoDemanda() {
      const d = this.demanda;
      this.credenciamento.analiseDemanda.id = d.id;
      this.credenciamento.analiseDemanda.sequencia = d.sequencia;
      this.credenciamento.analiseDemanda.numero = d.numero;
      this.credenciamento.analiseDemanda.siglaUnidadeOrganizacional = d.siglaUnidadeOrganizacional;
      this.credenciamento.analiseDemanda.razaoSocial = d.razaoSocial;
      this.credenciamento.analiseDemanda.situacao = d.situacao;
      this.credenciamento.analiseDemanda.uriRelatorioFornecimentoPedido = d.uriRelatorioFornecimentoPedido;
    },
    async buscarDocumentosParaAnalisar() {
      this.credenciamento.analiseDemanda.documento = this.formatarDocumento()
    },
    formatarDocumento() {
      const d = this.demanda;
      return {
        uri: d.uriRelatorioFornecimentoPedido,
        url: '/hal/public/arquivos?uri=' + d.uriRelatorioFornecimentoPedido + '&thumbnail=false',
      }
    },

    tratarEventoDeVoltar() {
      this.$router.push({
        name: 'CredenciamentoExecucaoFornecedor',
        params: {
          id: this.credenciamentoId
        }
      });
    },
    mostrarNotificacaoErro(msg) {
      this.$emit('erro', msg); // ou use snackbar/global notify
    },
    async exibirAnalise() {
      this.exibir = true
    },
    tratarEventoDownload(documento) {
      this.$store.dispatch(actionTypes.CREDENCIAMENTO.BAIXAR_DOCUMENTO, documento)
    },
  }
};
</script>

<style scoped lang='stylus'>
  .analise__area
    padding 0
    margin 0
    overflow-y auto
    padding-top 64px
    display flex

  @media (max-width 960px)
    .analise__area
      padding-top 48px

  @media (max-width 670px)
    .analise__area
      padding-top 56px
</style>